// React:
import React from "react";
// Redux Toolkit Hooks:
import { useAppSelector, useAppDispatch } from "../../../../app/hooks";
// Redux Toolkit Actions & State:
import { drawerOpenAndCloseAction, drawer } from "./drawerSlice";
import { directoryItems } from "../directory/directory-items/directoryItemsSlice";
// MUI Components:
import {
  Container,
  List,
  ListItem,
  ListItemButton,
  SvgIcon,
  Divider,
  useTheme,
} from "@mui/material";
// Components:
import DrawerItem from "./drawer-item/DrawerItem";
import AlternativeFileModal from "./drawer-item/drawer-share/alternative-file-modal/AlternativeFileModal";
import ResponsiveAlternativeFileModal from "./drawer-item/drawer-share/alternative-file-modal/responsive-alternative-file-modal/ResponsiveAlternativeFileModal";
// MUI Styles:
import { makeStyles } from "@mui/styles";
// Icones:
import { ReactComponent as ArrowLeftIcon } from "../../../../assets/icons/arrow-left-icon.svg";
import { ReactComponent as ArrowRightIcon } from "../../../../assets/icons/arrow-right-icon.svg";
import { ReactComponent as InfoIcon } from "../../../../assets/icons/info-icon.svg";
import { ReactComponent as ShareIcon } from "../../../../assets/icons/share-icon.svg";
import { ReactComponent as TableIcon } from "../../../../assets/icons/table-icon.svg";

const useStyles = makeStyles((theme) => ({
  drawerContainer: {
    width: "100%",
    height: "100%",
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.secondary,
    overflow: "hidden",
  },
  itemsBox: {
    width: "100%",
    height: "95%",
    padding: "8px 8px 8px 8px",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      borderRadius: "10px",
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      borderRadius: "10px",
      backdropFilter: "blur(4px)",
      backgroundColor: "rgba(28, 33, 45, 0.4)",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
      backgroundColor: theme.palette.secondary.main,
    },
  },
}));

const items = [
  {
    name: "info",
    icon: InfoIcon,
  },
  {
    name: "share",
    icon: ShareIcon,
  },
  {
    name: "share management",
    icon: TableIcon,
  },
];

const Drawer = () => {
  const classes = useStyles();
  const theme = useTheme();

  const dispatch = useAppDispatch();

  const { openDrawer } = useAppSelector(drawer);
  const { itemInfo } = useAppSelector(directoryItems);

  const menuItem = itemInfo.dir ? [items[0]] : items;

  return (
    <Container
      id="ignoreDisableTouch"
      sx={{
        p: { xs: 0 },
        m: { xs: 0 },
      }}
      className={classes.drawerContainer}
    >
      <List
        sx={{
          width: "100%",
          height: "65px",
          p: "8px",
          [theme.breakpoints.down("md")]: {
            height: "55px",
          },
        }}
      >
        <ListItem disablePadding>
          <ListItemButton
            sx={{
              width: "100%",
              height: "50px",
              display: "flex",
              justifyContent: openDrawer ? "flex-start" : "center",
              alignItems: "center",
              cursor: "pointer",
              backgroundColor: "inherit",
              borderRadius: "5px",
              p: "4px 8px",
              "&:hover": {
                filter: "brightness(95%);",
              },
              [theme.breakpoints.down("lg")]: {
                height: "45px",
              },
              [theme.breakpoints.down("md")]: {
                height: "40px",
              },
            }}
            onClick={(e) => {
              e.stopPropagation();
              dispatch(drawerOpenAndCloseAction());
            }}
          >
            <SvgIcon
              component={openDrawer ? ArrowRightIcon : ArrowLeftIcon}
              inheritViewBox
              sx={{
                width: "15px",
                height: "15px",
                color: "inherit",
              }}
            />
          </ListItemButton>
        </ListItem>
      </List>

      <Divider sx={{ opacity: "0.2" }} />

      <List
        sx={{
          width: "100%",
          height: "calc(100% - 66px)",
          p: "8px",
          overflowY: "auto",
          overflowX: "hidden",
        }}
        className={classes.itemsBox}
      >
        {menuItem.map((item, index) => (
          <DrawerItem key={index} item={item} index={index} />
        ))}
      </List>

      <AlternativeFileModal />
      <ResponsiveAlternativeFileModal />
    </Container>
  );
};

export default Drawer;
